var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.45455C9.59003 5.45455 7.63636 7.40821 7.63636 9.81818V16.3636H16.3636V9.81818C16.3636 7.40821 14.41 5.45455 12 5.45455ZM17.8182 16.3636V9.81818C17.8182 6.60488 15.2133 4 12 4C8.7867 4 6.18182 6.60488 6.18182 9.81818V16.3636H4.72727C4.32561 16.3636 4 16.6892 4 17.0909C4 17.4926 4.32561 17.8182 4.72727 17.8182H9.48032C9.65677 19.0517 10.7177 20 12 20C13.2823 20 14.3432 19.0517 14.5197 17.8182H19.2727C19.6744 17.8182 20 17.4926 20 17.0909C20 16.6892 19.6744 16.3636 19.2727 16.3636H17.8182ZM13.0288 17.8182H10.9712C11.1209 18.2419 11.525 18.5455 12 18.5455C12.475 18.5455 12.8791 18.2419 13.0288 17.8182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.aca4374b.svg";
export { ForwardRef as ReactComponent };